import React from "react"
import {Body, H3} from "@irati/ui/src/Typography"
import {FormattedMessage, FormattedNumber} from "@irati/utils/lang"
import {Hr} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {useBudgetsPermissions} from "@irati/wallet/hooks/budget"
import {DistributeRewardImportType} from "../../../enums/DistributeRewardTypes"
import {useRewardsDistribution} from "../../../stores/DistributeReward/hooks"
import {CategoryCircle} from "./styled"

const BudgetSummary = () => {
  const {category, unassigned, ...payload} = useRewardsDistribution()
  const {canBudget} = useBudgetsPermissions()
  if (!canBudget) {
    return null
  }

  const {pointsPerUser, destinationUsers, userEmails, rewardImportType} = payload
  const categoryAmount = category?.amount! / 100
  const unassignedAmount = unassigned?.amount! / 100
  const totalPoints =
    rewardImportType === DistributeRewardImportType.IMPORT_CSV
      ? pointsPerUser * userEmails.length
      : pointsPerUser * destinationUsers.length

  return (
    <>
      <H3 paddingLeft={3} paddingTop={4}>
        <FormattedMessage id="wallet.reward.admin.summary.title" />
      </H3>
      <Hr />
      {category && (
        <>
          <Flex direction="column" padding={[0, 3]} gap={0.5}>
            <Flex gap={0.5}>
              <CategoryCircle color={category?.metadata.color} />
              <Body small color={theme.colors.greys.black}>
                {category?.name}
              </Body>
            </Flex>
            <Flex justifyContent="space-between">
              <Flex direction="column">
                <Body small>
                  <FormattedMessage id="wallet.reward.budget.summary.currentBalance" />
                </Body>
                <Body small>
                  <FormattedMessage id="wallet.reward.budget.summary.pointAllocation" />
                </Body>
                <Body small>
                  <FormattedMessage id="wallet.reward.budget.summary.balanceAfterAllocation" />
                </Body>
              </Flex>
              <Flex direction="column">
                <Body small color={theme.colors.greys.black}>
                  <FormattedNumber value={categoryAmount} />
                </Body>
                <Body small color={theme.colors.utility.error}>
                  - <FormattedNumber value={totalPoints > categoryAmount ? categoryAmount : totalPoints} />
                </Body>
                <Body small color={theme.colors.greys.black}>
                  <FormattedNumber value={totalPoints > categoryAmount ? 0 : categoryAmount - totalPoints} />
                </Body>
              </Flex>
            </Flex>
          </Flex>
          <Hr />
        </>
      )}
      {unassigned && (
        <>
          <Flex direction="column" padding={[0, 3]} gap={0.5}>
            <Flex gap={0.5}>
              <CategoryCircle color={unassigned.metadata.color} />
              <Body small color={theme.colors.greys.black}>
                {unassigned?.name}
              </Body>
            </Flex>
            <Flex justifyContent="space-between">
              <Flex direction="column">
                <Body small>
                  <FormattedMessage id="wallet.reward.budget.summary.currentBalance" />
                </Body>
                <Body small>
                  <FormattedMessage id="wallet.reward.budget.summary.pointAllocation" />
                </Body>
                <Body small>
                  <FormattedMessage id="wallet.reward.budget.summary.balanceAfterAllocation" />
                </Body>
              </Flex>
              <Flex direction="column">
                <Body small color={theme.colors.greys.black}>
                  <FormattedNumber value={unassignedAmount} />
                </Body>
                <Body small color={theme.colors.utility.error}>
                  - <FormattedNumber value={category ? totalPoints - categoryAmount : totalPoints} />
                </Body>
                <Body small color={theme.colors.greys.black}>
                  {category ? (
                    <FormattedNumber value={unassignedAmount - (totalPoints - categoryAmount)} />
                  ) : (
                    <FormattedNumber value={unassignedAmount - totalPoints} />
                  )}
                </Body>
              </Flex>
            </Flex>
          </Flex>
          <Hr />
        </>
      )}
    </>
  )
}

export default BudgetSummary
